import UserPrenom from '@/generated/controls/user/UserPrenom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: UserPrenom
})
